import { NavigateType } from '../types/route';
import { useNavigate } from 'react-router-dom';

const useEnhancedNavigation = () => {
  const navigate = useNavigate();

  const navigateTo = (
    url: string | undefined,
    navigateType: NavigateType = NavigateType.DEFAULT,
  ) => {
    if (!url) return;

    const isExternal = url.startsWith('http://') || url.startsWith('https://');

    if (navigateType === NavigateType.OPEN_IN_NEW_TAB) {
      window.open(url, '_blank'); // Open external link in a new tab
    } else if (isExternal) {
      window.location.href = url; // Redirect to external link
    } else {
      navigate(url); // Navigate to internal route
    }
  };

  return navigateTo;
};

export default useEnhancedNavigation;
